import { defineMessages } from 'react-intl';

export default defineMessages({
	description: {
		id: 'components.walletPayment.notFound.description',
		defaultMessage: 'تراکنشی برای نمایش وجود ندارد',
	},
	homeButton: {
		id: 'components.walletPayment.notFound.homeButton',
		defaultMessage: 'بازگشت به صفحه اصلی',
	},
});
